import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class EsignService {

 constructor(private readonly http: HttpClient) {}

  getWalletAmount(payload:any): Observable<any> {
    let url = environment.API_URL + `/v1/transaction/get-wallet-info/${payload}`;
    return this.http.get(url);
  }
  
  addWalletAmount(payload: any): Observable<any> {
    let url = environment.API_URL + `/v1/transaction/credit-to-wallet`;
    return this.http.post(url, payload);
  }

  getWalletPaymentLink(payload: any): Observable<any> {
    let url = environment.API_URL + `/v1/transaction/generateLink`;
    return this.http.post(url, payload);
  }

  getLogs(page?: number): Observable<any> {
    let url = environment.API_URL + `/v1/public-esign`;
    if (page !== undefined) {
      url += `?page=${page}`;
    }
    return this.http.get(url);
  }

  getLogsCount(): Observable<any> {
    let url = environment.API_URL + `/v1/public-esign/count`;
    return this.http.get(url);
  }

  getCredits():Observable<any> {
    let url = environment.API_URL + `/v1/user-credit`;
    return this.http.get(url);
  }  

  getDocument(id:any):Observable<any>{
    let url = environment.API_URL + `/v1/public-esign/${id}`;
    return this.http.get(url);
  }

  getTransactionHistory(page?: number): Observable<any> {
    let url = environment.API_URL + `/v1/transaction/history`;
    if (page !== undefined) {
      url += `?page=${page}`;
    }
    return this.http.get(url);
  }

  getTransactionHistoryCount(): Observable<any> {
    let url = environment.API_URL + `/v1/transaction/history/count`;
    return this.http.get(url);
  }

  getStats(): Observable<any> {
    let url = environment.API_URL + `/v1/user-credit/stats`;
    return this.http.get(url);
  }

}
